// extracted by mini-css-extract-plugin
export default {"switchContainer":"AddressTypeSwitch_switchContainer__CdfxK","switchButton":"AddressTypeSwitch_switchButton__O+7oX","active":"AddressTypeSwitch_active__2zwkG"};